import { Form, Input, Row, Col, Switch, InputNumber, Select, message } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import systematic from '../../../config/systematic';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { getService } from '../../system/WebUniversal';

const EditComponent = (props: any) => {
    const apiId = 'deviceModel';
    const { defaultService } = props;
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [id, setId] = useState<string>();

    const [deviceTypeData, setDeviceTypeData] = useState<any>();
    const [brandData, setBrandData] = useState<any>();
    const [deviceDataProcessorData, setDeviceDataProcessorData] = useState<any>();

    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (res?.success === true) {
                const { id } = res.data;
                setId(id);
            }
        });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'deviceType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setDeviceTypeData(res.data);
                }
            })
        fetchApi.GET(getService('bm'),
            {
                query: {
                    apiId: 'brand',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setBrandData(res.data);
                }
            })
        fetchApi.GET(getService('bm'),
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'deviceDataProcessor',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { deviceDataProcessor } = res.data;
                    setDeviceDataProcessorData(deviceDataProcessor);
                }
            })
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'mf',
        displayOptions: {
            width: 1000
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={14}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="ID"
                                    name="id"
                                    tooltip="设备型号的唯一标识，由系统自动生成，创建后不可修改，通常仅用于系统内部关联与追溯。">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="品牌"
                                    name="brandId"
                                    tooltip="该型号所属的品牌。用于按品牌对设备型号进行归类与筛选；若为通用/白牌型号，可选择“空”或对应通用品牌。">
                                    <Select
                                        placeholder="品牌"
                                        showSearch={{
                                            optionFilterProp: 'children',
                                            filterOption: (input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}>
                                        {getList.general(brandData, { itemName: 'brandName', includeNull: true })}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="类型"
                                    name="deviceTypeId"
                                    tooltip="设备的功能类型（如传感器、网关、开关等）。用于区分设备用途并决定默认的控制/上报能力，类型数据来源于“设备类型”字典。">
                                    <Select
                                        placeholder="设备类型"
                                        showSearch={{
                                            optionFilterProp: 'children',
                                            filterOption: (input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}>
                                        {getList.general(deviceTypeData, { itemName: 'typeName' })}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="型号名"
                                    name="modelName"
                                    tooltip="型号的展示名称，用于在列表、下拉选择等界面显示，建议填写完整且易读的名称，如：ESP32-DevKitC。"
                                    rules={[{ required: true, message: '型号名称!' }]}>
                                    <Input placeholder="如：ESP32-DevKitC" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="编码"
                                    name="code"
                                    tooltip="型号的唯一编码，用于程序识别与设备上报匹配，必须全局唯一，建议使用小写字母、数字和短横线，组合形式: 设备类型(两位字母)mp_xxxx, 如：mp_esp32-devkitc。"
                                    rules={[{ required: true, message: '型号编码（唯一）!' }]}>
                                    <Input placeholder="如：mp_esp32-devkitc" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="蓝牙名前缀"
                                    name="bleNamePrefix"
                                    tooltip="设备蓝牙广播名称的公共前缀，用于配网/扫描时按前缀快速过滤该型号设备，如：ESP32_、MFR_。留空表示不按前缀过滤。">
                                    <Input placeholder="如：ESP32_、MFR_" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="主控芯片"
                                    name="chip"
                                    tooltip="设备使用的主控芯片具体型号，用于硬件识别、固件匹配与问题排查，如：ESP32-WROOM-32、STM32F103C8T6。">
                                    <Input placeholder="如：ESP32-WROOM-32、STM32F103C8T6" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="芯片家族"
                                    name="family"
                                    tooltip="主控芯片所属的芯片家族，用于按平台统一匹配固件和烧录参数，如：esp32、esp8266、stm32f1。">
                                    <Input placeholder="如：esp32、esp8266、stm32f1" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="制造商"
                                    name="manufacturer"
                                    tooltip="该型号的生产/制造厂商名称，用于溯源与售后区分，如：Espressif、ST。">
                                    <Input placeholder="如：Espressif、ST" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    name="specs"
                                    label="硬件参数"
                                    tooltip="型号的硬件规格参数，使用 JSON 格式填写，如：{&quot;flash&quot;:&quot;4MB&quot;,&quot;ram&quot;:&quot;520KB&quot;,&quot;gpio&quot;:34}。用于展示与后续能力判断。">
                                    <Input.TextArea
                                        rows={4}
                                        placeholder='{"flash":"4MB","ram":"520KB","gpio":34}'
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="数据处理方式"
                                    name="defaultDataProcessorId"
                                    tooltip="选择数据处理方式，用于发送设备把信息转换为接收设备可识别的数据。">
                                    <Select
                                        placeholder="数据处理方式"
                                        showSearch={{
                                            optionFilterProp: 'label',
                                            filterOption: (input, option: any) =>
                                                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}
                                        options={getList.general2(deviceDataProcessorData, { includeNull: true })}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="排序"
                                    name="sort"
                                    tooltip="列表展示时的排序权重，数值越小越靠前。用于调整型号在下拉/列表中的显示顺序，默认 0。">
                                    <InputNumber
                                        style={{ width: 60 }} />
                                </Form.Item>
                            </Col>

                            <Col span={7}>
                                <Form.Item
                                    label="心跳(秒)"
                                    name="reportInterval"
                                    tooltip="设备与平台之间发送心跳包的时间间隔，单位：秒。用于维持设备在线状态；建议小于平台离线判定超时时间。过小会增加功耗和流量，过大可能导致设备被误判离线。通常建议 30~300 秒，具体以设备协议为准。"
                                >
                                    <InputNumber style={{ width: 60 }} />
                                </Form.Item>
                            </Col>

                            <Col span={5}>
                                <Form.Item
                                    label="状态"
                                    name="isUse"
                                    valuePropName="checked"
                                    initialValue={true}
                                    tooltip="该型号是否启用。启用后可用于新增设备；关闭后不影响已关联设备，但不可再被新设备选择。">
                                    <Switch
                                        checkedChildren="启用"
                                        unCheckedChildren="关闭" />
                                </Form.Item>
                            </Col>

                        </Row>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label=""
                            name="description"
                            tooltip="型号的详细描述信息，支持富文本编辑，可填写使用说明、注意事项、硬件接口说明等内容，用于文档展示。">
                            <WangeditorV5ForAntD
                                key={id}
                                id={`deviceModel${id}`}
                                title='描述'
                                displayMode="editor"
                                defaultService={systematic.bmService}
                                style={{ height: 400 }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;